import { render } from "./HeaderDesktop.vue?vue&type=template&id=5289e699&scoped=true&ts=true"
import script from "./HeaderDesktop.vue?vue&type=script&lang=ts"
export * from "./HeaderDesktop.vue?vue&type=script&lang=ts"

import "./HeaderDesktop.vue?vue&type=style&index=0&id=5289e699&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5289e699"]])

export default __exports__